import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import {
  EntityStatus,
  EntityStatusInitialState,
} from './types/entityStatusTypes';
import { Nullable } from '../common/types';

export const initialState: EntityStatusInitialState = {
  entityStatus: null,
  errorMessage: '',
};

const entityStatusSlice = createSlice({
  name: 'entityStatus',
  initialState,
  reducers: {
    setEntityStatus: (state, action: PayloadAction<Nullable<EntityStatus>>) => {
      state.entityStatus = action.payload;
      state.errorMessage = '';
    },
    setEntityStatusError: (state, action: PayloadAction<string>) => {
      state.entityStatus = null;
      state.errorMessage = action.payload;
    },
    resetEntityStatus: (state) => {
      state.entityStatus = null;
      state.errorMessage = '';
    },
  },
});

export const { setEntityStatus, setEntityStatusError, resetEntityStatus } =
  entityStatusSlice.actions;

export const entityStatusSelectors = {
  selectEntityStatus: (state: RootState) => state.entityStatus.entityStatus,
  selectEntityStatusErrorMessage: (state: RootState) =>
    state.entityStatus.errorMessage,
};

export const getEntityStatus = createAction<{
  entityId: string;
}>('entityStatus/getEntityStatus');

export default entityStatusSlice.reducer;
